import {defineStore} from 'pinia';
import {ref} from 'vue';

export const usePasswordChangeStore = defineStore('passwordChange', () => {
    const isOpened = ref(false);
    const title = ref('');
    const message = ref('');
    const cancelText = ref('');
    const okText = ref('');
    const password = ref('');
    const newPassword = ref('');
    const confirmPassword = ref('');
    const forced = ref(false);
    const callback = ref(null);

    // 비밀번호 변경 관련 상태
    const isLoading = ref(false);

    const reset = () => {
        isOpened.value = false;
        title.value = '';
        message.value = '';
        cancelText.value = '';
        okText.value = '';
        password.value = '';
        newPassword.value = '';
        confirmPassword.value = '';
        forced.value = false;
        callback.value = null;
        isLoading.value = false;
    };

    const close = result => {
        isOpened.value = false;
        callback.value && callback.value(result);
    };

    const show = params => new Promise(r => {
        reset();
        if (params.title !== undefined) title.value = params.title;
        if (params.message !== undefined) message.value = params.message;
        if (params.cancelText !== undefined) cancelText.value = params.cancelText;
        if (params.okText !== undefined) okText.value = params.okText;
        if (params.forced !== undefined) forced.value = params.forced;

        isOpened.value = true;
        callback.value = r;
    });

    return {
        isOpened, title, message, cancelText, okText, password, newPassword, confirmPassword, forced, isLoading,
        show, close, reset,
    };
});
